import { useMemo, useState } from "react";
import { useTable } from "react-table";
import {
  // convertToTilteCase,
  defaultDateDisplay,
  formatCurrency,
} from "../../../helpers";
import primaryComponents from "../../primaryComponents";
// import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../routes/pathContants";

const useReturnsTable = ({ returns }) => {
  const [selectedOrder, setSelectedOrder] = useState(null);
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      {
        Header: "Date/Time",
        accessor: "id",
        Cell: ({ row }) => (
          <span>
            <span className="d-block">
              {row?.original?.order_dates?.length > 0
                ? defaultDateDisplay(
                    row?.original?.order_dates?.[
                      row?.original?.order_dates?.length - 1
                    ],
                  )
                : defaultDateDisplay(row?.original?.created_at)}
            </span>
          </span>
        ),
      },
      {
        Header: "Order Number",
        accessor: "order",
        Cell: ({ cell: { value, row } }) => (
          <Link
            className="smallest-text-size purple--text"
            onClick={() => {
              navigate(
                pathConstants.INVENTORY_SALES_TRANSACTIONS +
                  `?orderId=${row?.original?.order?.id}`,
              );
            }}
            style={{ textDecoration: "underline" }}
          >
            {row?.original?.order?.id || "N/A"}
          </Link>
        ),
      },
      {
        Header: "Return Amount",
        accessor: "total_returned_amount",
        Cell: ({ cell: { value }, row }) => (
          <span
            style={{
              color: value < 0 ? "#E02020" : "#27AE60",
              fontWeight: 500,
            }}
          >
            {formatCurrency({
              value: value,
              currencyCode: row?.original?.store?.currency_code,
            })}
          </span>
        ),
      },
      // {
      //   Header: "Return Status",
      //   accessor: "return_status",
      //   Cell: ({ cell: { value } }) => {
      //     let backgroundColor = "#EFEFEF";
      //     let textColor = "#666";
      //     let displayText = "NO RETURN";

      //     if (value === "FULL_RETURN") {
      //       backgroundColor = "#FFEEE9";
      //       textColor = "#E02020";
      //       displayText = "FULL RETURN";
      //     } else if (value === "PARTIAL_RETURN") {
      //       backgroundColor = "#FEF7EB";
      //       textColor = "#F2994A";
      //       displayText = "PARTIAL RETURN";
      //     }

      //     return (
      //       <span
      //         className={`${globalStyles.statusBlock} gray--text`}
      //         style={{
      //           background: backgroundColor,
      //           color: textColor,
      //           whiteSpace: "nowrap",
      //           fontSize: "10px",
      //         }}
      //       >
      //         {displayText}
      //       </span>
      //     );
      //   },
      // },
      {
        Header: "Cashier",
        accessor: "cashier",
        Cell: ({ cell: { value } }) => value?.first_name || "N/A",
      },
      {
        Header: "Customer",
        accessor: "customer",
        Cell: ({ cell: { value, row } }) =>
          row?.original?.order?.customer?.full_name ? (
            <Link
              className="smallest-text-size purple--text"
              to={pathConstants.CUSTOMER_DETAILS({
                customerId: row?.original?.order?.customer?.id,
              })}
              style={{ textDecoration: "underline" }}
            >
              {row?.original?.order?.customer?.full_name}
            </Link>
          ) : (
            "N/A"
          ),
      },
      {
        Header: "Store",
        accessor: "store",
        Cell: ({ cell: { value } }) => value?.name || "N/A",
      },
      // {
      //   Header: "Amount",
      //   accessor: "total_item_amount",
      //   Cell: ({ cell: { value }, row }) =>
      //     formatCurrency({
      //       value: value,
      //       currencyCode: row?.original?.store?.currency_code,
      //     }),
      // },
      {
        Header: "Actions",
        accessor: "actions",
        Cell: ({ row }) => (
          <primaryComponents.Button
            className="btn btn--primary smallBtn"
            onClick={() => {
              setSelectedOrder(row?.original?.id);
            }}
          >
            View
          </primaryComponents.Button>
        ),
      },
    ],
    [],
  );

  const instance = useTable({
    columns,
    data: returns,
  });

  return {
    instance,
    selectedOrder,
    setSelectedOrder,
  };
};

export default useReturnsTable;
